<template>
    <div class="van-keep">
        <div class="container">
            <section class="date-header">
               链接将于 {{yxqText}}后失效，请尽快完成填写。  
            </section>
            <p class="pos-abs abs1" @click="showUserAgreementDialog(2)">填写说明</p>
            <p class="pos-abs abs2" v-if="this.formData.SHYJ" @click="showUserAgreementDialog(3)">审核信息</p>
            <section class="form-content">
                <el-form class="my-form-content" :rules="rules" ref="ruleForm" :model="formData" label-width="120px">
                    <el-row class="my-form-item" :gutter="40">
                        <el-col :span="12">
                            <el-form-item label="合同名称：" prop="HTMC">
                                <el-input readonly v-model.trim="formData.HTMC" v-if="formEditState" ></el-input>
                               <span v-else> {{ formData.HTMC }}</span>
                            </el-form-item>
                            <el-form-item label="采购方式：">
                                <el-select v-model="formData.CGFS" class="w-full" clearable v-if="formEditState" placeholder="请选择">
                                    <el-option v-for="item in procurementTypeDropdownList" :key="item.Id+''" :label="item.Name" :value="item.Id+''"/>
                                </el-select>
                               <span v-else-if="!formEditState&&procurementTypeDropdownList.find(item=>item.Id+'' === formData.CGFS)"> {{ procurementTypeDropdownList.find(item=>item.Id+'' === formData.CGFS)['Name'] }}</span>
                            </el-form-item>
                            <!-- <el-form-item label="乙方机构编码：" prop="HTMC">
                                <el-input v-model.trim="formData.BYZD4" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.BYZD4}}</span>
                            </el-form-item> -->
                            <!-- <el-form-item label="销售人员：">
                                <el-input v-model.trim="formData.name" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.name }}</span>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="12">
                             <el-form-item label="合同编号：" prop="HTBH">
                                <el-input readonly v-model.trim="formData.HTBH" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.HTBH }}</span>
                            </el-form-item>
                            <el-form-item label="签订日期：">
                                <el-date-picker v-model="formData.HTSJ" style="width: 100%;" v-if="formEditState" type="date" placeholder="选择日期时间"> </el-date-picker>
                               <span v-else> {{ formData.HTSJ }}</span>
                            </el-form-item>
                            <!-- <el-form-item label="联系方式：">
                                <el-input v-model.trim="formData.phone" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.phone }}</span>
                            </el-form-item> -->
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row class="my-form-item" :gutter="40">
                        <el-col :span="24">
                            <h4>签约方</h4>
                            <el-table :data="formData.signParties" border size="mini" style="width: 100%">
                                <el-table-column prop="role" align="center" label="签约方" width="80"></el-table-column>
                                <el-table-column label="机构名称">
                                    <template slot="header">
                                        <span>机构名称</span>
                                        <span style="color: #F56C6C;"> *</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.role==='甲方'">{{ scope.row.orgName }}</span>
                                        <template v-else>
                                            <template v-if="formEditState">
                                                <el-form-item class="mb-0" :prop="`signParties.${scope.$index}.orgName`" label-width="auto" :rules="[{ required: true, message: '请输入机构名称', trigger: 'blur' }]">
                                                    <el-select
                                                        v-model="scope.row.orgName"
                                                        size="mini"
                                                        filterable
                                                        remote
                                                        allow-create
                                                        reserve-keyword
                                                        placeholder="请输入关键词搜索"
                                                        clearable
                                                        :loading="scope.row.loading"
                                                        :remote-method="(query)=>remoteMethodSupplierDropdown(query,scope.$index)"
                                                        @change="(e)=>supplierDropdownChangeHandle(e,scope.$index)"
                                                    >
                                                        <el-option v-for="item in supplierDropdownList" :key="item.a" :label="item.b" :value="item.b"/>
                                                    </el-select>

                                                </el-form-item>
                                            </template>
                                            <span v-else>{{ scope.row.orgName }}</span>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column label="地址">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.role==='甲方'">{{ scope.row.address }}</span>
                                        <template v-else-if="formEditState">
                                            <el-input v-model.trim="scope.row.address" :disabled="scope.$index === 0" size="mini" placeholder="非必填"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.address }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="联系人" width="140">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.role==='甲方'">{{ scope.row.contact }}</span>
                                        <template v-else-if="formEditState">
                                            <el-input v-model.trim="scope.row.contact" size="mini" :disabled="scope.$index === 0" placeholder="非必填"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.contact }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="联系方式" width="180">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.role==='甲方'">{{ scope.row.phone }}</span>
                                        <template v-else-if="formEditState">
                                            <el-input v-model.trim="scope.row.phone" size="mini" :disabled="scope.$index === 0" placeholder="非必填"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.phone }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="邮箱" width="220">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.role==='甲方'">{{ scope.row.email }}</span>
                                        <template v-else-if="formEditState">
                                            <el-input v-model.trim="scope.row.email" size="mini" :disabled="scope.$index === 0" placeholder="非必填"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.email }}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="操作" width="80" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-plus" circle @click="onClickAddParty(scope.row)"></el-button>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </el-col>
                         <el-col :span="24">
                            <h4><span>设备清单</span>
                            <el-button size="mini" icon="el-icon-plus" v-if="formEditState" @click="addEquipRow">添加设备</el-button></h4>
                            <el-table
                                :data="formData.equipList"
                                show-summary 
                                :summary-method="getSummaries" 
                                border
                                size="mini" 
                                style="width: 100%"
                            >
                                <el-table-column prop="name" width="180" label="设备名称" align="center">
                                    <template slot="header">
                                        <span>设备名称</span>
                                        <span style="color: #F56C6C;"> *</span>
                                    </template>
                                    <template slot-scope="scope">
                            
                                        <template v-if="formEditState">
                                            <el-select
                                                class="w-full"
                                                v-model="scope.row.SBBM"
                                                size="mini"
                                                filterable
                                                remote
                                                allow-create
                                                reserve-keyword
                                                clearable
                                                placeholder="请输入关键词搜索"
                                                :loading="scope.row.nameLoading"
                                                :remote-method="(query)=>remoteMethodSBMCDropdown(query,scope.$index)"
                                                @change="(e)=>SBMCDropdownChangeHandle(e,scope.$index)"
                                            >
                                                <el-option v-for="item in SBMCDropdown[scope.$index]" :key="item.a" :label="item.b" :value="item.a"/>
                                            </el-select>
                                        </template>
                                        <span v-else>{{ scope.row.SBBM }}</span>
                                    </template>
                                </el-table-column>
                                
                                 <el-table-column prop="DW" label="单位" width="100"  align="center">
                                    <template slot-scope="scope">
                                         <template v-if="formEditState">
                                           <el-input  v-model.trim="scope.row.DW" size="mini"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.DW }}</span>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="GGXH" label="规格型号" width="140"  align="center">
                                    <template slot-scope="scope">
                                         <template v-if="formEditState">
                                           <el-input  v-model.trim="scope.row.GGXH" size="mini"></el-input>
                                        </template>
                                        <span v-else>{{ scope.row.GGXH }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="* 数量" width="100"  align="center">
                                      <template slot="header">
                                        <span>数量</span>
                                        <span style="color: #F56C6C;"> *</span>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-form-item  v-if="formEditState" class="mb-0" :prop="`equipList.${scope.$index}.SL`" :rules="[{ required: true, message: '请输入数量', trigger: 'blur' }]" label-width="0">
                                            <el-input v-model.number="scope.row.SL" class="text-center" size="mini" placeholder="1" @input="updateEquipRow(scope.row)" />
                                        </el-form-item>
                                        <span v-else>{{ scope.row.SL }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单价" width="140"  align="center">
                                    <template slot-scope="scope">
                                       <el-input
                                        v-if="formEditState"
                                        v-model="scope.row.DJ"
                                        class="text-center"
                                        size="mini"
                                        placeholder="0"
                                        @input="(value) => {
                                            scope.row.DJ = value.replace(/[^\d.]/g,'').replace(/^(\d*\.\d{0,4}).*$/, '$1');
                                            updateEquipRow(scope.row);
                                        }"
                                        />
                                         <span v-else>{{ scope.row.DJ }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="注册证件号" width="140"  align="center">
                                    <template slot-scope="scope">
                                       <el-input
                                        v-if="formEditState"
                                        v-model="scope.row.ZCZJH"
                                        class="text-center"
                                        size="mini"
                                        placeholder="0"
                                        />
                                         <span v-else>{{ scope.row.DJ }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="设备序列号" width="140"  align="center">
                                    <template slot-scope="scope">
                                        <div class="sbxlh-wrap" @click="()=>{
                                            if(formEditState){
                                                openSBXLHDialog(scope.row.SBXLH,scope.$index,scope.row.SL)
                                            }
                                        }">
                                            <div v-if="scope.row.SBXLH">
                                                <template v-if="scope.row.SBXLH.split(',').length === 1">
                                                    <el-tag type="primary" class="series-tag" size="mini">{{scope.row.SBXLH.split(',')[0]}}</el-tag>
                                                </template>
                                                <template v-else>
                                                    <el-tag type="primary" class="series-tag" size="mini">{{scope.row.SBXLH.split(',')[0]}}</el-tag>
                                                   +{{scope.row.SBXLH.split(',').length - 1}}
                                                </template>
                                               
                                            </div>
                                            <span v-else>点击添加序列号</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                 <el-table-column prop="SCCSMC" label="生产厂商" width="200"  align="center">
                                    <template slot-scope="scope">
                                        <template v-if="formEditState">
                                            <el-select
                                                v-model="scope.row.SCCSMC"
                                                size="mini"
                                                filterable
                                                remote
                                                allow-create
                                                reserve-keyword
                                                clearable
                                                placeholder="请输入关键词搜索"
                                                :loading="scope.row.manufacturerLoading"
                                                :remote-method="(query)=>remoteMethodfactoryDropdown(query,scope.$index)"
                                                @change="(e)=>factoryDropdownChangeHandle(e,scope.$index)"
                                            >
                                                <el-option v-for="item in factoryDropdownList[scope.$index]" :key="item.a" :label="item.b" :value="item.a"/>
                                            </el-select>
                                        </template>
                                        <span v-else>{{ scope.row.SCCSMC }}</span>
                                    </template>
                                </el-table-column>

                                 <el-table-column prop="brand" label="国家" width="100"  align="center">
                                    <template slot-scope="scope">
                                         <template v-if="formEditState">
                                            <el-select v-model="scope.row.GB" filterable clearable allow-create size="mini">
                                                <el-option v-for="item in countryDropDownList" :key="item.a" :label="item.b" :value="item.a"/>
                                            </el-select>
                                        </template>
                                        <span v-else-if="!formEditState&&getCountryName(scope.row.GB)">{{ getCountryName(scope.row.GB) }} </span>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="brand" label="品牌" width="160"  align="center">
                                    <template slot-scope="scope">
                                         <template v-if="formEditState">
                                            <el-select v-model="scope.row.PPMC" @change="(e)=>changeBrandHandle(e,scope.$index)" filterable clearable allow-create size="mini">
                                                <el-option v-for="item in brandDropdown" :key="item.a" :label="item.b" :value="item.a"/>
                                            </el-select>
                                        </template>
                                        <span v-else>{{ scope.row.PPMC }}</span>
                                    </template>
                                </el-table-column>
                               
                               
                                
                                <el-table-column label="总金额" width="100"  align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.totalAmount || '0.00' }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" label="操作" width="80" align="center"  v-if="formEditState&&(formData.SHZT!='3') && showEdit">
                                    <template slot-scope="scope">
                                        <el-link type="danger" @click="removeEquipRow(scope.$index)">移除</el-link>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                        <el-col :span="24">
                            <h4>器械交付日期</h4>
                            <div class="contract-item">
                                乙方在合同生效的
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.YFHTSXTS"  min="1">
                                天内向甲方交付上述器械。
                            </div>
                            <h4>器械运输、安装和验收</h4>
                            <div class="contract-item">
                                （1）乙方还应在发货前
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.YFJDAZTS"  min="1">
                               个工作日通知甲方器械的运输信息以及到货时间。
                            </div>
                            <div class="contract-item">
                                （2）器械到货后，乙方应在接到甲方通知后
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.YFTSWCTS"  min="1">
                               天内安装调试完成。
                            </div>
                            <div class="contract-item">
                                （3）甲乙双方对器械进行开箱清点检查验收，如果发现数量不足或有质量、技术等问题，乙方应在
                                <input type="number" :readonly="!formEditState" class="my-form-number" v-model="formData.YFBZTS"  min="1"> 天内，按照甲方的要求，采取补足、更换或退货等处理措施。
                            </div>
                             <h4>付款条件</h4>
                            <div class="contract-item">
                                甲方在收到乙方发票并确认无误后，应在
                                <input type="number" :readonly="!formEditState" class="my-form-number" v-model="formData.JFFPFKYS"  min="1">
                                个月内支付货款，共计
                                <input type="number" :readonly="!formEditState" class="my-form-number" readonly v-model="formData.totalEquipAmount"  min="1">
                                元，大写：{{formData.totalEquipAmount?convertToChineseMoney(formData.totalEquipAmount):'-'}}
                            </div>
                            <h4>乙方收款账户信息如下：</h4>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="开户名：" prop="YFSKKHM">
                                <el-input  v-model.trim="formData.YFSKKHM" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.YFSKKHM }}</span>
                            </el-form-item>
                             <el-form-item label="开户银行：" prop="YFSSKKHYH">
                                <el-input v-model.trim="formData.YFSSKKHYH" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.YFSSKKHYH }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="纳税人识别号：" prop="YFSSKNSRSBH">
                                <el-input v-model.trim="formData.YFSSKNSRSBH" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.YFSSKNSRSBH }}</span>
                            </el-form-item>
                             <el-form-item label="银行账号：" prop="YFSSKYHZH">
                                <el-input v-model.trim="formData.YFSSKYHZH" v-if="formEditState"></el-input>
                               <span v-else> {{ formData.YFSSKYHZH }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <h4>质量保证及售后服务</h4>
                            <div class="contract-item">
                               乙方应保证所供器械是在  
                                  <el-date-picker :readonly="!formEditState" v-model="formData.ZBRQ" size="small"   type="date"placeholder="选择日期"> </el-date-picker>
                                后生产的全新的、未使用过的，并符合国家有关标准、行业有关标准、制造厂标准及合同技术标准要求。
                            </div>
                            <div class="contract-item">
                                <p style="margin-bottom: 20px;">质保期服务条件</p>
                                （1）甲方进行故障报修后，乙方应在
                                 <input type="number" :readonly="!formEditState" class="my-form-number" v-model="formData.ZBBXJXFZS"  min="1"></input>
                                  <el-select :readonly="!formEditState" v-model="formData.ZBBXJXFZSDW" placeholder="请选择" size="small" style="width: 80px;">
                                    <el-option label="小时" value="小时"></el-option>
                                    <el-option label="分钟" value="分钟"></el-option>
                                    <el-option label="天" value="天"></el-option>
                                </el-select>
                                内接修，接修后应在
                                <input type="number" :readonly="!formEditState" class="my-form-number" v-model="formData.ZBBXDDXCXSS"  min="1"></input>
                                  <el-select :readonly="!formEditState" v-model="formData.ZBBXDDXCXSSDW" placeholder="请选择"  size="small" style="width: 80px;">
                                    <el-option label="小时" value="小时"></el-option>
                                    <el-option label="分钟" value="分钟"></el-option>
                                    <el-option label="天" value="天"></el-option>
                                </el-select>
                                内到达现场。
                            </div>
                             <div class="contract-item">
                                （2）为保障甲方设备的正常运行，乙方应每年做预防性维护
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.YFYZNYFXWHCS"  min="1"></input>
                                次、检测
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.YFYZNYFXJCCS"  min="1"></input>
                                次，每次维护后，乙方提供设备运行状况报告给甲方备案。
                            </div>
                            <div class="contract-item">
                                （3）保修的设备在一年内开机率保证在
                                 <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.ZBNKJLBFB"  min="1"></input>
                                %以上，每年设备累计停机时长不超过
                                 <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.ZBNJTSCBGYTS"  min="1"></input>
                                个工作日。
                            </div>
                             <div class="contract-item">
                                （4）在保修期内，涉及到不在保修范围内的器件，如需更换，乙方以市场价的
                                <input type="number" class="my-form-number" :readonly="!formEditState" v-model="formData.ZBJQYHLBFB"  min="1"></input>
                                %优惠提供。
                                <el-form-item label="服务备注：" prop="remark" style="margin-top: 20px;">
                                    <el-input  type="textarea" :rows="4" v-model.trim="formData.ZBFWBZ" v-if="formEditState"></el-input>
                                    <span v-else> {{ formData.remark }}</span>
                                </el-form-item>
                            </div>
                             <h4>其他关键条款</h4>
                             <el-table :data="formData.HTFKList" border size="mini" style="width: 100%">
                                <el-table-column label="条款项" width="80" align="center">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.BH }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="条款内容">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.Name" v-if="formEditState" type="textarea" :rows="2" size="mini"  placeholder="请输入条款内容"/>
                                        <span v-else> {{ scope.row.Name }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="120" align="center" v-if="formEditState">
                                    <template slot-scope="scope">
                                        <el-button  type="primary" icon="el-icon-plus" circle size="mini" @click="addTermRow"/>
                                        <el-button  type="danger" icon="el-icon-minus" circle size="mini" @click="removeTermRow(scope.$index)"/>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>

                         <el-col :span="24">
                            <h4>相关文件</h4>
                                <div class="contract-item">
                                    <el-row :gutter="20">
                                        <el-col :span="6">
                                            <div></div>
                                            <div 
                                                class="upload-file-list-item" 
                                                v-for="item in basicSetDropdownList" 
                                                :key="item.Id"
                                                :class="selectedFileType === item.Id ? 'active-item':''"
                                                @click="()=>((selectedFileType = item.Id),(uploadQueue = []))"
                                            >
                                                <span class="name"> {{item.Name}} </span>
                                                <span class="count"> 
                                                    <template v-if="Array.isArray(formData.HTFJList)&&formData.HTFJList.filter(fjItem=>fjItem.FJLX == item.Id).length>0">
                                                        已上传 
                                                        <i>{{formData.HTFJList.filter(fjItem=>fjItem.FJLX == item.Id).length}}</i>
                                                        个文件
                                                    </template>
                                                    <template v-else>
                                                        未上传
                                                    </template>
                                                </span>
                                            </div>
                                        </el-col>
                                         <el-col :span="18">
                                            <el-upload
                                                action=""
                                                class="upload-demo w-full text-center"
                                                :style="{height: (basicSetDropdownList.length*40)+'px'}"
                                                :auto-upload="false"
                                                multiple
                                                :on-change="changeFileHandle"
                                                :file-list="selectFileList"
                                                :before-upload="beforeUpload"
                                                :on-exceed="handleExceed"
                                                :on-remove="removeFileHandle"
                                                :limit="10"
                                                accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf"
                                                drag
                                                :disabled="formData.SHZT=='3'||!showEdit"
                                            >
                                                <i class="el-icon-upload"></i>
                                                <div class="el-upload__text" v-if="formData.SHZT=='3'||!showEdit">已提交审核，不可上传</div>
                                                <div class="el-upload__text" v-else>将文件拖到此处，或<em>点击上传</em></div>
                                                <div class="el-upload__tip" slot="tip">
                                                    <el-button  size="small" type="primary" icon="el-icon-upload2" @click="submitFilesHandle" :disabled="!uploadQueue.length">上传到服务器</el-button>
                                                    <span>
                                                      只能上传 JPG/PNG/PDF文件，且不超过100MB，最多{{10-selectFileList.length}}/10个文件
                                                    </span>
                                                </div>
                                                <template slot="file" slot-scope="{ file }">
                                                    <div class="file-item">
                                                        <div>
                                                            <i :class="`${checkLinkInFileType(file.FJLJ||file.name) === 'image'?'el-icon-picture':'el-icon-collection'}` "></i>
                                                            <span>{{ file.FJMC||file.name }}</span>
                                                            <span :style="{color:file.HTBH?'#67C23A':'#E6A23C'}">（{{file.HTBH?'已上传':'未上传'}}）</span>
                                                        </div>
                                                        <div>
                                                            <!-- <el-progress :percentage="file.percentage" v-if="file.status === 'uploading'"></el-progress> -->

                                                            <el-button type="text" icon="el-icon-view" size="mini"  @click="previewFile(file)">预览</el-button>
                                                            <el-button v-if="file.HTBH" type="text" icon="el-icon-download" size="mini" @click="downloadFileHandle(file)">下载</el-button>
                                                            <el-button type="text" size="mini" @click="removeFileHandle(file, selectFileList)"><span style="color: #F56C6C;">删除</span></el-button>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-upload>
                                        </el-col>
                                    </el-row>
                                    
                                </div>
                            <h4>备注</h4>
                            <el-input type="textarea" :rows="4" placeholder="请输入备注" :readonly="!formEditState" v-model="formData.BZ"></el-input>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <section class="submit-footer">
                <div v-if="!formEditState">
                    <el-button size="small" @click="goBack">关闭</el-button>
                    <el-button type="primary" @click="formEditState=true" size="small" v-if="formData.SHZT!='3'&&showEdit">编辑</el-button>
                </div>
                <div v-else>
                    <el-button  size="small" @click="formEditState=false">取消</el-button>
                    <el-button type="primary" @click="submitForm" size="small" :disabled="loading">保存</el-button>
                </div>
                <div class="userAgreement">
                    <el-checkbox v-model="userAgreementStatus">已阅读 </el-checkbox>
                    <span class="detail" @click="showUserAgreementDialog(1)">用户协议</span>
                </div>
            </section>
        </div>
       <SetSBXLHDialog ref="setSBXLHDialogRef" @saveSBXLH="handleSaveSBXLH"/>
       <DescribeDialog ref="describeDialogRef"/>
       <UserAgreementDialog ref="userAgreementDialogRef"/>
       <el-image-viewer v-if="fileimage" :on-close="()=>{fileimage=false,filepaths=''}" :url-list="[filepaths]"/>
    </div>
</template>

<script>
import { Toast, Popup, Picker } from "vant";
import SetSBXLHDialog from '@/components/supplierCollaboration/setSBXLHDialog'
import DescribeDialog from '@/components/supplierCollaboration/describeDialog'
import UserAgreementDialog from '@/components/supplierCollaboration/userAgreementDialog'
import { convertToChineseMoney } from '../../../tool/amount.js'
import { checkLinkInFileType,formatFilePath } from '../../../tool/verification.js'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { api } from '../../../config/index.js'
export default {
    name: "supCollabShare",
    data() {
        return {
            supplierInfo: {},
            loading: true,
            formEditState:false,
            showEdit:true,
            selectedFileType:'',
            selectSBXLHIndex:null,
            formData:{
                YFSKKHM: '',      // 开户名（账户名称）
                YFSSKNSRSBH: '',       // 纳税人识别号（纳税人ID）
                YFSSKKHYH: '',         // 开户银行（银行名称）
                YFSSKYHZH: '',       // 银行账号（银行账户号码）
                signParties:[
                    { role:'甲方', orgName:'', address:'', contact:'', phone:'', email:'' },
                    { role:'乙方', orgName:'', address:'', contact:'', phone:'', email:'', loading:false }
                ],
                equipList:[],
                totalEquipAmount: 0,  // 设备清单合计总金额
                // paymentPlan: [
                //     { term: '首期', ratio: 21.00, amount: 0 }
                // ],  // 付款计划
                HTFKList: [
                    { Name: '',BH:1 }
                ],  // 其他关键条款
                HTFJList: [],  // 附件列表
            },
            factoryDropdownList:[],  //厂家下拉信息
            procurementTypeDropdownList:[], //采购方式下拉
            supplierDropdownList:[],  //供应商下拉
            SBMCDropdown:[],  //设备名称下拉信息
            brandDropdown:[],  //品牌下拉信息获取
            basicSetDropdownList:[],  //附件类型下拉加载
            countryDropDownList:[],  //国别下拉
            userAgreementStatus:true, 
            uploadQueue: [], // 文件上传队列
            uploadTimer: null, // 上传防抖定时器
            rules: {
                HTMC: [
                    { required: true, message: '请输入合同名称', trigger: 'blur' },
                ],
                HTBH: [
                    { required: true, message: '请输入合同编号', trigger: 'blur' },
                ],
                BYZD4: [
                    { required: true, message: '请输入乙方机构编码', trigger: 'blur' },
                ],
            },
            convertToChineseMoney,
            checkLinkInFileType,
            formatFilePath,
            fileimage:false,
            filepaths:""
        };
    },
    components: {
        DescribeDialog,UserAgreementDialog,ElImageViewer,SetSBXLHDialog
    },
    computed: {
        yxqText() {
            if (!this.supplierInfo || !this.supplierInfo.YXQ) return "";
            return this.formatDateToCn(this.supplierInfo.YXQ, true);
        },
        linkExpired() {
            if (!this.supplierInfo || !this.supplierInfo.YXQ) return false;
            return this.isExpired(this.supplierInfo.YXQ, true);
        },
        selectFileList(){
           let arr = this.formData.HTFJList.filter(item=>item.FJLX == this.selectedFileType)
            //console.log(this.uploadQueue,arr)
            return [...this.uploadQueue,...arr]
        },
        getCountryName(val){
            return function (val){
                if(!this.countryDropDownList.length||!val) return ''
                return this.countryDropDownList.find(item=>item.a == val)['b']
            }
        }
    },
    mounted() {
        let paramsId = this.$route.params.id||null
        const verifyCode = this.$store.getters.SupCollabShareVerifyCode;
        if(!paramsId){
             this.$router.replace(`/sup-collab-share`)
        }else if(typeof verifyCode !== 'string') {
            this.$router.replace(`/sup-collab-share/${paramsId}`)
        }else{
            this.verifyCode();
        }
       
    },
    methods: {
        onClickAddParty(){
            // 占位：暂不实现
        },
        addEquipRow(){
            this.formData.equipList.push({ 
               SBBM:'',
                SBBH:'',
                SL:0,
                DJ:'',
                DW:'',
                GGXH:'',
                SCCS:'',
                PP:'',
                GB:'',
                PPMC:'',
                SCCSMC:'',
                nameLoading:false,
                manufacturerLoading:false,
  
            });
            this.factoryDropdownList.push([])
            this.SBMCDropdown.push([])
        },
        removeEquipRow(index){
            this.formData.equipList.splice(index,1);
            this.factoryDropdownList.splice(index,1);
            this.SBMCDropdown.splice(index,1);
            this.calculateTotalEquipAmount();
        },
        updateEquipRow(row){
            // 计算当前行总金额
            const qty = Number(row.SL || 0);
            const price = Number(row.DJ || 0);
            row.totalAmount = (qty * price).toFixed(2);
            // 重新计算合计总金额
            this.calculateTotalEquipAmount();
        },
        calculateTotalEquipAmount(){
            const total = this.formData.equipList.reduce((acc, row) => {
                return acc + Number(row.totalAmount || 0);
            }, 0);
            this.formData.totalEquipAmount = total.toFixed(2);
        },
       
        getPaymentSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '共计(元)';
                    return;
                }
                if (column && column.label === '付款金额(元)') {
                    const total = data.reduce((acc, row) => {
                        return acc + Number(row.amount || 0);
                    }, 0);
                    sums[index] = total.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        addTermRow(){
            this.formData.HTFKList.push({ Name: '',BH:this.formData.HTFKList.length + 1 });
        },
        removeTermRow(index){
            if(!this.formData.HTFKList[index].HTBH){
                this.formData.HTFKList.splice(index, 1);
            }else{
                let paramsId = this.$route.params.id||null
                if (!paramsId) return 
                this.$get("api/HtTran/DelHTTK", { HTBH: paramsId,BH: this.formData.HTFKList[index].BH})
                .then(res => {
                    this.formData.HTFKList.splice(index, 1);
                })
                .catch(_=>{
                    this.$Toast.fail('额外条款删除失败');
                })
            }
            
        },
        showUserAgreementDialog(type){
            if(type===1){
                this.$refs['userAgreementDialogRef'].dialogVisible = true
            }else if( type === 2){
                 this.$refs['describeDialogRef'].dialogVisible = true
            }else{
                 this.$alert(`<div style="white-space: pre-line;">${this.formData.SHYJ.replace(/\\r\\n/g, '\n')}</div>`, '审核信息', { confirmButtonText: '确定', dangerouslyUseHTMLString: true})
            }
        },
        openSBXLHDialog(sbxlh,index,max){
            this.$refs['setSBXLHDialogRef'].openDialog(sbxlh,max)
            this.selectSBXLHIndex = index
        },
        handleSaveSBXLH(tags){
             this.$set( this.formData.equipList,this.selectSBXLHIndex, {... this.formData.equipList[this.selectSBXLHIndex],SBXLH:tags.join(',')})
            this.selectSBXLHIndex = null
        },
        goBack(){
            this.$router.replace(`/sup-collab-share/${this.$route.params.id}`)
        },
        verifyCode(){
             let paramsId = this.$route.params.id||null
             if (!paramsId) return (this.loading = false);
             this.$get('/api/HtTran/CheckXTCode', {JYM:this.$store.getters.SupCollabShareVerifyCode,HTBH: paramsId })
             .then(res=>{
                if(res.Status||res.status){
                    this.supplierInfo = res.Ht;
                    const prev = { ...this.formData };
                    this.formData = { ...prev, ...res.Ht };
                    this.formData.ZBBXJXFZSDW = !res.Ht.ZBBXJXFZSDW?'分钟':res.Ht.ZBBXJXFZSDW
                    this.formData.ZBBXDDXCXSSDW = !res.Ht.ZBBXDDXCXSSDW?'小时':res.Ht.ZBBXDDXCXSSDW
                    if(res.Ht.SHYJ){
                       this.$alert(`<div style="white-space: pre-line;">${res.Ht.SHYJ.replace(/\\r\\n/g, '\n')}</div>`, '审核信息', { confirmButtonText: '确定', dangerouslyUseHTMLString: true})
                    }
                    this.$set( this.formData.signParties, 0,  { role:'甲方', orgName:res.YYMC, address:res.Ht.JFDZ, contact:res.Ht.JFLXR, phone:res.Ht.JFLXDH, email:res.Ht.JFYJ })
                    this.$set( this.formData.signParties, 1,  { role:'乙方', orgName:res.Ht.HTDWMC, address:res.Ht.BYZD3, contact:res.Ht.QYLXR, phone:res.Ht.QYLXDH, email:res.Ht.BYZD2 })
                    if(Array.isArray(res.ItemList)&&res.ItemList.length){
                        let equipList = []
                        res.ItemList.forEach(item=>{
                            equipList.push({
                                SBBM:item.SBBM,
                                SBBH:item.SBBH,
                                SL:item.SL||0,
                                DJ:item.DJ,
                                DW:item.DW,
                                GGXH:item.GGXH,
                                SCCS:item.SCCS,
                                PP:item.PP,
                                GB:item.GB,
                                PPMC:item.PPMC,
                                SCCSMC:item.SCCSMC,
                                ZCZJH:item.ZCZJH,
                                SBXLH:item.SBXLH,
                                nameLoading:false,
                                manufacturerLoading:false,
                            })
                            this.factoryDropdownList.push([])
                            this.SBMCDropdown.push([])
                        })
                        this.formData.equipList = [...equipList]
                        // 计算每行的总金额
                        this.formData.equipList.forEach((row, index) => {
                            this.updateEquipRow(row);
                        });
                    }
                    if(Array.isArray(res.HTFKList)&&res.HTFKList.length){
                        this.formData.HTFKList = [...res.HTFKList]
                    }
                    if(Array.isArray(res.HTFJList)&&res.HTFJList.length){
                        this.formData.HTFJList = [...res.HTFJList.map(item=>({...item,name:item.FJMC})).sort((a, b) => b.HH - a.HH)]
                    }
                    this.getProcurementTypeDropdown(paramsId)
                    this.getBrandDropdown(paramsId)
                    this.getCountryDropdown(paramsId)
                    this.getBasicSetDropdown(paramsId)
                }else{
                    this.$Toast.fail(res.Msg||'验证失败！自动返回上一页');
                    setTimeout(()=>{
                        this.$router.replace(`/sup-collab-share/${paramsId}`)
                    },1000)
                }
                 this.loading = false;
            })
            .catch(_=>{
                this.$Toast.fail('验证失败！自动返回上一页');
                 setTimeout(()=>{
                    this.$router.replace(`/sup-collab-share/${paramsId}`)
                },1000)
                 this.loading = false;
            })
        },
        changeBrandHandle(e,index){
            let selected = this.brandDropdown.find(item=>item.a === e)
             if(selected){
                   this.formData.equipList[index].PPMC = selected.b
                   this.formData.equipList[index].PP = selected.a
             }else{
                this.formData.equipList[index].PPMC = e
             }
        },
        supplierDropdownChangeHandle(e,index){
            let selected = this.supplierDropdownList.find(item=>item.a === e)
            if(!selected) return
            // console.log(selected,this.formData.signParties)
            // this.formData.signParties[1].orgName = 
             this.formData.signParties[index].phone = selected.d||''
             this.formData.signParties[index].contact = selected.c||''
        },
        remoteMethodSupplierDropdown(query,index) {  //供应商下拉 搜索方法
            if (query === '')  return
            this.formData.signParties[index].loading = true
            let self = this
            setTimeout(() => {
                self.getSupplierDropdown(query,index)
            }, 300);
        },
        getSupplierDropdown(q,index){  // 供应商下拉
            if(!q) return
            this.$get("api/HtTran/SupplierDropdown", { q })
            .then(res => {
                if (res.Status || res.status) {
                   this.supplierDropdownList = [...res.Data]
                }
                this.formData.signParties[index].loading = false
            })
            .catch(_=>{
               this.formData.signParties[index].loading = false
            })
        },
        remoteMethodfactoryDropdown(query,index) {  //厂家下拉信息获取 搜索方法
            if (query === '')  return
            this.formData.equipList[index].manufacturerLoading = true
            let self = this
            setTimeout(() => {
                self.getFactoryDropdown(query,index)
            }, 300);
        },
        getFactoryDropdown(q,index){  //厂家下拉信息获取 
            this.$get("api/HtTran/FactoryDropdown", { q })
            .then(res => {
                if (res.Status || res.status) {
                    this.factoryDropdownList[index] = [...res.Data]
                }
             this.formData.equipList[index].manufacturerLoading = false
            })
            .catch(_=>{
               this.formData.equipList[index].manufacturerLoading = false
            })
        },
        getProcurementTypeDropdown(paramsId){  // 采购方式下拉加载
            this.$get("api/HtTran/ProcurementTypeDropdown", { HTBH: paramsId })
            .then(res => {
                if (res.Status || res.status) {
                   this.procurementTypeDropdownList = [...res.Data]
                }
            })
        },
        factoryDropdownChangeHandle(e,index){
            if(!this.factoryDropdownList[index]) return
            let selected = this.factoryDropdownList[index].find(item=>item.a === e)
            if(selected){
                this.formData.equipList[index].SCCS = selected.a
            } 
           this.formData.equipList[index].SCCSMC = selected?selected.b:e
        },
        SBMCDropdownChangeHandle(e,index){
            if(!this.SBMCDropdown[index]) return
            let selected = this.SBMCDropdown[index].find(item=>item.a === e)
            if(selected){
                this.formData.equipList[index].SBBH = e
                this.formData.equipList[index].SBBM = selected.b
                this.formData.equipList[index].DJ = selected.dj||0
                this.formData.equipList[index].DW = selected.d||''
                this.formData.equipList[index].GGXH = selected.c||''
            }else{
              this.formData.equipList[index].SBBM = e  
            }
        },
        remoteMethodSBMCDropdown(query,index) {  //设备名称下拉信息获取 搜索方法
            if (query === '')  return
            this.formData.equipList[index].nameLoading = true
            let self = this
            setTimeout(() => {
                self.getSBMCDropdown(query,index)
            }, 300);
        },
        getSBMCDropdown(q,index){  // 设备名称下拉信息获取
            this.$get("api/HtTran/SBMCDropdown", { q })
            .then(res => {
                if (res.Status || res.status) {
                   this.SBMCDropdown[index] = [...res.Data]
                }
             this.formData.equipList[index].nameLoading = false
            })
            .catch(_=>{
               this.formData.equipList[index].nameLoading = false
            })
        },
        
        getCountryDropdown(HTBH){  // 国别下拉信息获取
            this.$get("api/HtTran/CountryDropdown", { HTBH })
            .then(res => {
                if (res.Status || res.status) {
                   this.countryDropDownList= [...res.Data]
                }
            })
        },
        getBrandDropdown(HTBH){  // 品牌下拉信息获取
            this.$get("api/HtTran/BrandDropdown", { HTBH })
            .then(res => {
                if (res.Status || res.status) {
                   this.brandDropdown= [...res.Data]
                }
            })
        },
        getBasicSetDropdown(HTBH){  // 附件类型下拉加载
            this.$get("api/HtTran/BasicSetDropdown", { HTBH })
            .then(res => {
                if (res.Status || res.status) {
                   this.basicSetDropdownList= [...res.Data]
                   this.selectedFileType = res.Data[0].Id
                }
            })
        },
        // 将 ISO 日期字符串格式化为：YYYY年MM月DD日 HH时mm分ss秒
        // 当 endOfDay 为 true 时，时间固定为当日 23:59:59
        formatDateToCn(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return "";
            if (endOfDay) {
                date.setHours(23, 59, 59, 0);
            }
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${year}年${month}月${day}日 ${hours}时${minutes}分${seconds}秒`;
        },
        // 是否晚于当前时间（默认比较当日 23:59:59）
        isAfterNow(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return false;
            if (endOfDay) date.setHours(23, 59, 59, 0);
            return date.getTime() > Date.now();
        },
        // 是否已过期（当前时间是否超过给定时间；默认按当日 23:59:59 截止）
        isExpired(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return true;
            if (endOfDay) date.setHours(23, 59, 59, 0);
            return Date.now() > date.getTime();
        },
         getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '成交总价（元）';
                    return;
                }
                if (column && column.label === '总金额') {
                    sums[index] = this.formData.totalEquipAmount;
                } else if(column && column.label === '生产厂商'){
                    sums[index] ='大写：'+ this.convertToChineseMoney(this.formData.totalEquipAmount);
                }else {
                    sums[index] = '';
                }
            });
            return sums;
        },
       
        handleSubmit() {
            this.$refs['ruleForm'].validate(valid => {
                if (!valid) return;
                if (!this.verifyCode) {
                    this.$Toast("请填写验证码");
                    return;
                }
                // TODO: 发起提交请求
            });
        },
        handleUploadSuccess(response, file, fileList, item) {
            if (response.Status || response.status) {
                item.fileList = fileList;
                this.$Toast.success("上传成功");
            } else {
                this.$Toast.fail(response.Msg || "上传失败");
            }
        },
        handleUploadError(err, file, fileList) {
            this.$Toast.fail(err.message || "上传失败");
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$Toast.fail("文件大小不能超过 100MB!");
            }
            return isLt100M;
        },
        handleExceed(files, fileList) {
            this.$Toast.fail(`最多只能上传 10 个文件！`);
            return false;
        },
        previewFile(file) {
        // 先取文件名
            let fileName = file.FJLJ.split('/').pop();
            this.downloadFileHandle(file)
            // 调用下载接口拿 blob
            this.$axios.get(api.fileUploadApi+'/api/FileUpload/download/' + file.HTBH + '/' + this.extractFilename(file.FJLJ), {
                responseType: 'blob',
            }).then(resp => {
                const blob = new Blob([resp.data], { type: resp.headers['content-type'] || 'application/octet-stream' });
                const fileUrl = window.URL.createObjectURL(blob);

                // 判断文件类型
                const fileType = this.checkLinkInFileType(file.FJLJ || file.name);

                if (fileType === 'image') {
                    this.filepaths = fileUrl;
                    this.fileimage = true;
                } else if (fileType === 'pdf') {
                    window.open(fileUrl, '_blank');
                } else {
                    this.$message.warning('暂不支持该文件类型预览');
                }
            }).catch(err => {
                this.$Toast.fail('预览文件失败！');
                console.error(err);
            });
        },
        downloadFileHandle(file){
            this.$axios.get(api.fileUploadApi+'/api/FileUpload/download/' + file.HTBH + '/' +  this.extractFilename(file.FJLJ), {
                responseType: 'blob',
            }).then(resp => {
                // resp.data 是 Blob
                const blob = new Blob([resp.data], { type: resp.headers['content-type'] || 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = file.name || fileName;  // 设置下载后的文件名
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                this.$Toast.fail('下载文件失败！');
                console.error(err);
            });
        },
        // 定义处理函数，兼容多种路径分隔符
        extractFilename(path) {
        // 匹配正斜杠(/)或反斜杠(\)，使用正则表达式统一处理
        const parts = path.split(/[\\/]/);
        // 返回最后一个非空部分（处理可能的空字符串情况）
        return parts.filter(part => part).pop();
        },
        removeFileHandle(file, fileList){
            // 如果是已上传的文件（有HTBH），从formData.HTFJList中删除
            let paramsId = this.$route.params.id||null
             if (!paramsId) return 
            if (file.HTBH) {
                const index = this.formData.HTFJList.findIndex(item => item.uid === file.uid);
                if (index < 0) return
                this.$get('api/HtTran/DelHTFJ',{FJLJ: file.FJLJ,HH:file.HH,HTBH: paramsId }).then(resp => {
                    this.formData.HTFJList.splice(index, 1);
                }).catch(err => {
                    this.$Toast.fail('删除文件失败！');
                });
            } else {
                // 如果是待上传的文件，从uploadQueue中删除
                this.uploadQueue = fileList.filter(item => !item.HTBH&&item.uid !== file.uid);
            }
        },
        changeFileHandle(file, fileList){
            // 只保留待上传的文件（没有HTBH的文件）
            this.uploadQueue = fileList.filter(item => !item.HTBH);
        },
        submitFilesHandle(){
            if(!this.uploadQueue.length) return
            const formData = new FormData();
            
            // 逐个添加文件，确保每个文件都是 File 对象
            this.uploadQueue.forEach(file => {
                formData.append('Files', file.raw || file);
            });
            
            const uploadData = this.getUploadData();
            Object.keys(uploadData).forEach(key => {
                formData.append(key, uploadData[key]);
            });
            // this.$post('/api/FileUpload/uploadHts', formData, {
            //     headers: { 'Content-Type': 'multipart/form-data' }
            // })
            this.$axios.post(api.fileUploadApi+'/api/FileUpload/uploadHts', formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000  // 可选：设置超时时间
            })
            .then(res => {
                if (res.data.status || res.data.Status) {
                    // 批量上传成功，处理返回的文件数据
                    res.data.imgList.forEach(fileInfo => {
                        // 构造符合 el-upload 文件列表格式的对象
                        const fileItem = {
                            name: fileInfo.fjmc, // 文件名
                            url: fileInfo.fjlj, // 文件路径
                            status: 'success', // 上传状态
                            uid: Date.now() + Math.random(), // 唯一标识
                            // 保存后端返回的完整信息
                            HTBH: fileInfo.htbh,
                            JCHH: fileInfo.jchh,
                            HH: fileInfo.hh,
                            FJMC: fileInfo.fjmc,
                            FJLJ: fileInfo.fjlj,
                            FJLX: fileInfo.fjlx,
                            BZ: fileInfo.bz,
                            ZHXGR: fileInfo.zhxgr,
                            ZHXGRQ: fileInfo.zhxgrq,
                            MakeTime: fileInfo.makeTime,
                            FKId: fileInfo.fkId
                        };
                        // 添加到 formData.HTFJList
                        this.formData.HTFJList.unshift(fileItem);
                    });
                    // 清空上传队列
                    this.uploadQueue = [];
                    this.$Toast.success(`成功上传 ${res.data.imgList.length} 个文件`);
                } else {
                    this.$Toast.fail(res.data.msg || "批量上传失败");
                }
                
            }).catch(err => {
                if (err.response && err.response.status === 503) {
                    this.$Toast.fail("服务器暂时不可用，请稍后重试");
                } else {
                    this.$Toast.fail("批量上传失败: " + (err.message || '未知错误'));
                }
            });
        },
      
        getUploadData() {
            return {
                HTBH: this.$route.params.id,
                FJLX: this.selectedFileType,
                JCHH: 0, // 文件行号 必传 累计最大值+1
                HH:(() => {
                    const validNums = this.formData.HTFJList.map(i => Number(i.HH)).filter(n => isFinite(n));
                    return (validNums.length ? Math.max(...validNums) : 0) + 1;
                })()
            };
        },
        submitForm(){
            let { equipList,signParties,HTFKList,HTFJList,...data } = {...this.formData}
            if(equipList.length < 1) return this.$notify.error({ title: '保存失败', message: '至少添加1个设备信息'});
            let isSbxlhLengthStatus = true
            let isSbxlhLengthIndex = null

            for (let index = 0; index < equipList.length; index++) {
                const item = equipList[index];
                if(item.SBXLH&&item.SBXLH.split(',').length!==0&&item.SBXLH.split(',').length !== item.SL){
                    isSbxlhLengthStatus = false
                    isSbxlhLengthIndex = index
                    break
                }
            }
            if(!isSbxlhLengthStatus){
                this.$notify.error({ title: '保存失败', message: `设备信息中第${isSbxlhLengthIndex+1}个数据中，设备数量与设备序列号数量不匹配！`});
                return
            }
            let parmas = {
                HTFKList,
                HTFJList,
                ItemList:equipList,
                HT:{
                    ...data,
                    QYLXDH:signParties[1].phone,
                    QYLXR:signParties[1].contact,
                    HTDWMC:signParties[1].orgName,
                    YFDZ:signParties[1].address,
                    BYZD2:signParties[1].email,
                }
                
            }
            this.$post('/api/HtTran/SaveXTXX', parmas).then(res => {
               //console.log(res)
               if(res.Status || res.status){
                 this.$confirm('数据已保存成功，是否立即提交审核？', '提示', {
                    confirmButtonText: '提交',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true, // 区分取消和关闭
                    type: 'warning'
                }).then(() => {
                    // 点击确定
                    this.$message({ type: 'info', message: '正在提交审核...' });  
                    let paramsId = this.$route.params.id || null
                    this.$get("/api/HtTran/SubmitGSYXT", { HTBH: paramsId })
                        .then(res => {
                            if (res.Status || res.status) {
                                this.$Toast.success(`提交成功！`);
                                this.formEditState = false
                                this.showEdit = false
                            }else{
                                this.$message({ type: 'error', message: res.Msg });
                            }
                        })
                }).catch(action => {
                    if (action === 'cancel') {
                        this.$message({ type: 'info', message: '已取消' });
                    } else {
                        this.$message({ type: 'info', message: '已关闭对话框' });
                    }
                });
               }else{
                    this.$Toast.fail( "保存失败");
               }
            }).catch(err => {
                 this.$Toast.fail(err || "保存失败");
            });

        }
    }
};
</script>

<style scoped lang="scss">
.van-keep {
    background-color: #f0f2f5;
    height: 100vh;
    overflow-y:hidden;
    .inline-block{
    display: inline-block;
    }
    .w-full{
        width: 100%;
    }
    .mb-0{
        margin-bottom: 0;
    }
    .container{
        width: 1200px;
        margin:0 auto;
        height: 100%;
        background-color: #fff;
        // 关键：用 flex 垂直布局
        display: flex;
        flex-direction: column;
        position: relative;
        .pos-abs {
            position: absolute;
            right: -38px;
            height: 86px;
            width: 30px;
            padding: 4px;
            top: 200px;
            color: #fff;
            background-color: #1890FF;
            border-color: #1890FF;
            text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
            -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
            box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
            text-align: center;
            border-radius: 6px;
            cursor: pointer;
        }
        .abs2{
            top: 400px;
        }
        .sbxlh-wrap{
            width: 100%;
            text-align: center;
            height: 28px;
            line-height: 28px;
            color:#adadad;
            font-size: 12px;
            border-radius:4px;
            border:1px solid #DCDFE6;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
                 border:1px solid #b8babe;
            }
            div{
                height: 28px;
                line-height: 28px;
                display: flex;
                 align-items: center;
                justify-content: center;
            }
            .series-tag{
                max-width: 100px;
               white-space: nowrap;
               overflow: hidden;
               text-overflow: ellipsis;

            }
        }
    }
    .date-header{
        border-bottom: 1px solid #e8e8e8;
        padding: 15px;
        text-align: center;
        color: #1890FF;
        font-size: 16px;
        flex-shrink: 0; // 固定高度，不被压缩
    }
    .submit-footer{
        border-top: 1px solid #e8e8e8;
        padding: 12px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0; // 固定在底部
        .userAgreement{
            display: flex;
            align-items: center;
        }
        .detail{
            margin-left: 10px;
            font-size: 14px;
            color:#1890FF;
        }
    }
    .form-content{
        flex: 1; // 占满剩余空间
        overflow-y: auto; // 表单内容多时可滚动
        padding: 10px;
        .my-form-content{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
        }
        .my-form-item{
           width: 900px;
           margin: 0 auto;
           width: 100%;
           h4{
                color: rgba(0, 0, 0, 0.85);
                font-weight: 500;
                font-size: 16px;
                margin: 24px 0 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
           }
           .contract-item{
                margin-bottom: 14px;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.7);
                .upload-file-list-item{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 40px;
                    line-height: 40px;
                    cursor: pointer;
                    padding: 4px 6px;
                    box-sizing: border-box;
                    transition: background .2s;
                    color:#666;
                    &.active-item{
                        background-color: #f0f2f5;
                        span.name{
                            color: #1890ff;
                            font-weight: bold;
                        }
                    }
                    .name{
                        font-size: 14px;
                    }
                    .count{
                        font-size: 12px;
                    }
                    i{
                        font-style: normal;
                        color: #67C23A;
                    }
                }
                .upload-demo{
                    background-color:#f0f2f5;
                    height: 100%;
                    min-height: 200px;
                    .el-upload__tip{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .file-item{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
           }
           .my-form-number{
                border-bottom: 1px solid #DCDFE6;
                text-align: center;
                color: #333;
                font-size: 16px;
                width:120px;
                text-align: center;
           }
        }
    }
}
</style>


<style  lang="scss">
.van-keep {
   .text-center .el-input__inner{
        text-align: center !important;
    }
    .el-form-item__error{
        position: inherit;
    }
    .el-upload.el-upload--text,.el-upload-dragger{
        width: 100%;
    }
    .el-upload-dragger{
        height: 120px;
        .el-icon-upload{
            margin-top: 20px;
        }
    }
    .upload-demo {
        &>.el-upload__tip{
            padding: 0 10px;
        }
        .el-upload-list{
            height: calc(100% - 170px);
            overflow-y: auto;
            padding: 0 10px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/page/supplierCollaboration/index.vue